import { Application, Point } from 'pixi.js'
import appConfig from '../../data/appConfig'
import { getLatestState, updateState } from '../gameState'
import spritePool from '../spritePool'
import { walrusBody } from './p2'

const { xLimit, yLimit } = appConfig.level

export const levels = [] as string[]
for (let y = 1; y <= yLimit; y++) {
	for (let x = 1; x <= xLimit; x++) {
		levels.push(`${y}-${x}`)
	}
}

export const changeLevelSystem = (app: Application) => {
	const {
		level: { currentLevelIndex },
	} = getLatestState()
	const walrusMainBody = spritePool.walrusMainBody
	const currentLevelIndexX = Math.floor(walrusMainBody.position.x / appConfig.width)
	const currentLevelIndexY = -Math.floor(walrusMainBody.position.y / appConfig.height)

	const newLevelIndex = currentLevelIndexX + currentLevelIndexY * xLimit
	if (currentLevelIndex !== newLevelIndex) {
		// console.log(newLevelIndex)
		spritePool.world?.gotoAndStop(newLevelIndex)
		const newPivot = new Point(currentLevelIndexX * appConfig.width, currentLevelIndexY * -appConfig.height)
		app.stage.pivot.set(newPivot.x, newPivot.y)
		spritePool.world?.position.copyFrom(newPivot)
		updateState({
			level: {
				currentLevelIndex: newLevelIndex,
				startedAt: performance.now(),
			},
		})
	}
}

export const resetLevelSystem = (app: Application) => {
	const {
		level: { currentLevelIndex },
		player,
	} = getLatestState()
	if (currentLevelIndex < -12) {
		spritePool.world?.gotoAndStop(0)
		app.stage.pivot.set(0, 0)
		spritePool.world?.position.set(0, 0)
		walrusBody.velocity = [0, 0]
		walrusBody.position = [100, 150]
		updateState({
			level: {
				currentLevelIndex: 0,
				startedAt: performance.now(),
			},
			player: {
				...player,
				jumpCharge: 0,
			},
		})
	}
}

document.addEventListener('keydown', e => {
	if (process.env.NODE_ENV === 'production') return
	if (e.key === '[' || e.key === ']') {
		const isForward = e.key === ']'
		let {
			level: { currentLevelIndex },
		} = getLatestState()
		if (isForward && currentLevelIndex < levels.length - 1) ++currentLevelIndex
		if (!isForward && currentLevelIndex > 0) --currentLevelIndex
		walrusBody.position[0] = (currentLevelIndex % xLimit) * appConfig.width + appConfig.width * 0.5
		walrusBody.position[1] = Math.floor(currentLevelIndex / xLimit) * -appConfig.height + appConfig.height * 0.1
	}
})
